import { graphql, HttpResponse } from 'msw'
import { type EnrollmentDisclosuresV2Data, type EnrollmentDisclosuresV2SubmitOutput } from '../../../../../models'

export const getEnrollmentDisclosuresV2DataMock: EnrollmentDisclosuresV2Data = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/disclosures/',
  enrollmentData: {
    userInfo: {
      investment: {
        disclosures: [
          {
            disclosureName: 'IRA Customer Agreement',
            disclosureUri: `https://www.google.com`,
            disclosureId: '123',
          },
          {
            disclosureName: 'Privacy Policy',
            disclosureUri: `https://www.google.com/1`,
            disclosureId: '802',
          },
          {
            disclosureName: 'Form CRS',
            disclosureUri: `https://www.google.com/2`,
            disclosureId: '305',
          },
        ],
      },
    },
  },
}

export const submitEnrollmentDisclosuresV2DataMock: EnrollmentDisclosuresV2SubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investmets/confirm-info',
}

export const mockGetEnrollmentDisclosuresV2Data = graphql.mutation('getEnrollmentDisclosuresV2Data', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentDisclosuresV2DataMock } })
})

export const mockSubmitEnrollmentDisclosuresV2Data = graphql.mutation('submitEnrollmentDisclosuresV2Data', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentDisclosuresV2DataMock } })
})

export const mockEnrollmentDisclosuresV2 = [mockGetEnrollmentDisclosuresV2Data, mockSubmitEnrollmentDisclosuresV2Data]
